import HubspotFormModal from "modal/HubspotFormModal";
import {handleHubspotForm} from "util/hubspot";
import {svg_include} from "../index";

export default class ContactModal extends HubspotFormModal {

    buildModal() {
        let offices = {};

        if ('undefined' !== typeof window.Offices) {
            offices = window.Offices;
        }

        let $offices = (eotwJSXFactory('div'));

        {offices.forEach((office) => {
            $offices.append(buildSidebar(office));
        })}

        this.$modal = (
            eotwJSXFactory('div', {className: "modal modal--contact"}, [
                eotwJSXFactory('div', {className: "modal__bg js-close-modal"}),
                eotwJSXFactory('div', {className: "modal__container"}, [
                    eotwJSXFactory('button', {className: "modal__close-btn close-btn close-btn--small close-btn--dark js-close-modal"}),
                    eotwJSXFactory('div', {className: "modal__content"}, [
                        eotwJSXFactory('div', {className: "modal__header"}, [
                            eotwJSXFactory('h2', {className: "heading heading--2"}, ["Contacta Anka"]),
                            eotwJSXFactory('p', null, ["Completa el formulario y nos pondremos en contacto contigo"])
                        ]),
                        eotwJSXFactory('div', {className: "modal__form form form--white"}, [
                            eotwJSXFactory('div', {className: "js-hubspot-container hubspot-container", 'data-hubspot-class': "contact-offices",
                                 'data-portal-id': "2188024", 'data-form-id': this.formId})
                        ])
                    ]),
                    eotwJSXFactory('div', {className: "modal__side"}, [
                        eotwJSXFactory('div', {className: "modal__header modal__header--left-aligned modal__header--border-bot"}, [
                            eotwJSXFactory('h2', {className: "heading heading--3"}, ["Nuestras oficinas"])
                        ]),
                        $offices
                    ])
                ])
            ])
        );
    }
}

function buildSidebar(office) {
    let $items = (eotwJSXFactory('ul', {className: "icon-list"}));

    office.items.forEach((item) => {
        $items.append(buildItem(item.type, item.text, item.link));
    })

    return (
        eotwJSXFactory('div', {className: "modal__office-location"}, [
            eotwJSXFactory('h3', {className: "heading heading--4"}, [office.office_country]),
            $items
        ])
    );
}

function buildItem(type, text, link) {
    if ("undefined" === typeof type || "undefined" === typeof text || "undefined" === typeof link ) return;

    let link_prefix = type === "tel" ? "tel" : "mailto";
    let icon = type === "tel" ? "list-icon-phone" : "list-icon-email";

    return (
        eotwJSXFactory('li', {className: "icon-list__item"}, [
            eotwJSXFactory('a', {href: link_prefix + ":" + link, className: "icon-list__link"}, [
                eotwJSXFactory('div', {className: "icon-list__icon", unsafeHtml: svg_include(icon)}),
                text])
        ])
    );
}